import { TReportFilters } from "@/types";

export const DEFAULT_REPORT_FILTERS: TReportFilters = {
	scope: "client",
	client: undefined,
	project: undefined,
	dateFrom: undefined,
	dateTo: undefined,
	sortType: "asc",
};
